import { Toolbar, ToolbarProps } from "@faro-lotv/flat-ui";
import { forwardRef, type JSX } from "react";

const FORCE_DARK = { dark: true };

/**
 * @returns a flat-ui Toolbar for the canvas overlays, dark in every color scheme
 */
export const OverlayToolbar = forwardRef<HTMLDivElement, ToolbarProps>(
  function OverlayToolbar({ sx, ...rest }, ref): JSX.Element {
    return (
      <Toolbar
        ref={ref}
        // Workaround: The `dark` prop is being added as part of ST-4745.
        // Spreading it on the component makes it compatible with both master and dark mode release branch.
        {...FORCE_DARK}
        // Positioned, so its surface paints above the absolutely positioned R3F canvas
        sx={[{ position: "relative" }, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
      />
    );
  },
);
